export default __webpack_public_path__ + "static/media/ronakpic.3173a9fd.jpg";